import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { IFormattedProviderProps } from '../../store/tables/admin/provider-data';

export enum PROVIDER_DETAILS_FORM_FIELDS {
  PROVIDER_NAME = 'name',
  MCC = 'mcc',
  PROCESSOR_ID = 'processorId',
  SUPPORT_MIT = 'supportMIT',
  SUPPORT_CIT = 'supportCIT',
  SANDBOX = 'sandbox',
  ETHOCA_PROVIDER = 'ethocaProvider',
  RDR_PROVIDER = 'rdrProvider',
  CHARGEBACK_PROVIDER = 'chargebacksManagementProvider',
  FIXED_DESCRIPTOR_PREFIX = 'fixedDescriptorPrefix',
  MC_DESCRIPTOR_PREFIX = 'masterCardDescriptorPrefix',
  VISA_DESCRIPTOR_PREFIX = 'visaDescriptorPrefix',
  PARTNER_ID = 'partnerId',
  MERCHANT_NUMBER = 'merchantNumber',
  SPONSOR_BANK = 'sponsorBank',
  PROCESSOR_PLATFORM = 'processorPlatform',
  CAID = 'caid',
  BIN = 'bin',
  RISK_TIER = 'tier',
  TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT = 'totalMonthlyMaxTransactionsCount',
  TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE = 'totalMonthlyMaxTransactionsValue',
  TOTAL_TRANSACTION_COUNT = 'totalTransactionCount',
  TOTAL_TRANSACTION_VALUE = 'totalTransactionAmount',

  TOTAL_DAILY_MAX_TRANSACTIONS_COUNT = 'totalDailyMaxTransactionsCount',
  TOTAL_DAILY_MAX_TRANSACTIONS_VALUE = 'totalDailyMaxTransactionsValue',
  TOTAL_DAILY_TRANSACTION_COUNT = 'totalDailyTransactionCount',
  TOTAL_DAILY_TRANSACTION_VALUE = 'totalDailyTransactionAmount',

  MC_MONTHLY_MAX_TRANSACTIONS_COUNT = 'masterCard_MonthlyMaxTransactionsCount',
  MC_MONTHLY_MAX_TRANSACTIONS_VALUE = 'masterCard_MonthlyMaxValue',
  MC_CURRENT_TRANSACTIONS_COUNT = 'masterCardCurrentTransactionsCount',
  MC_CURRENT_TRANSACTIONS_VALUE = 'masterCardCurrentTransactionsValue',

  VISA_MONTHLY_MAX_TRANSACTIONS_COUNT = 'visa_MonthlyMaxTransactionsCount',
  VISA_MONTHLY_MAX_TRANSACTIONS_VALUE = 'visa_MonthlyMaxValue',
  VISA_CURRENT_TRANSACTIONS_COUNT = 'visaCurrentTransactionsCount',
  VISA_CURRENT_TRANSACTIONS_VALUE = 'visaCurrentTransactionsValue',

  NAME = 'contactName',
  EMAIL = 'contactEmail',
  PHONE = 'contactPhone',
}

export enum PROVIDER_DETAILS_FORM_FIELDS_NAMES {
  PROVIDER_NAME = 'Provider',
  MCC = 'MCC',
  PROCESSOR_ID = 'Processor id',
  SUPPORT_MIT = 'MIT support',
  SUPPORT_CIT = 'CIT support',
  SANDBOX = 'Sandbox',
  ETHOCA_PROVIDER = 'Ethoca provider',
  RDR_PROVIDER = 'RDR provider',
  CHARGEBACK_PROVIDER = 'Chargebacks provider',
  FIXED_DESCRIPTOR_PREFIX = 'Fixed descriptor prefix',
  MC_DESCRIPTOR_PREFIX = 'MC descriptor prefix',
  VISA_DESCRIPTOR_PREFIX = 'Visa descriptor prefix',
  PARTNER_ID = 'Partner',
  MERCHANT_NUMBER = 'Merchant number',
  SPONSOR_BANK = 'Sponsor bank',
  PROCESSOR_PLATFORM = 'Processor platform',
  CAID = 'CAID',
  BIN = 'BIN',
  RISK_TIER = 'Risk tier',
  TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT = 'Total monthly max count',
  TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE = 'Total monthly max value',
  TOTAL_DAILY_MAX_TRANSACTIONS_COUNT = 'Total daily max count',
  TOTAL_DAILY_MAX_TRANSACTIONS_VALUE = 'Total daily max value',
  TOTAL_TOOLTIP_TEXT = 'Remove value to set as unlimited',
  MC_MONTHLY_MAX_TRANSACTIONS_COUNT = 'MC monthly max count',
  MC_MONTHLY_MAX_TRANSACTIONS_VALUE = 'MC monthly max value',
  VISA_MONTHLY_MAX_TRANSACTIONS_COUNT = 'Visa monthly max count',
  VISA_MONTHLY_MAX_TRANSACTIONS_VALUE = 'Visa monthly max value',
  NAME = 'Name',
  EMAIL = 'Email',
  PHONE = 'Phone',
}

export interface IProviderDetailsForm {
  [PROVIDER_DETAILS_FORM_FIELDS.PROVIDER_NAME]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.MCC]: string | number;
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_ID]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_MIT]: boolean;
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_CIT]: boolean;
  [PROVIDER_DETAILS_FORM_FIELDS.SANDBOX]: boolean;
  [PROVIDER_DETAILS_FORM_FIELDS.ETHOCA_PROVIDER]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.RDR_PROVIDER]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.CHARGEBACK_PROVIDER]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.FIXED_DESCRIPTOR_PREFIX]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.MC_DESCRIPTOR_PREFIX]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.PARTNER_ID]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.SPONSOR_BANK]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_PLATFORM]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.MERCHANT_NUMBER]: string | number;
  [PROVIDER_DETAILS_FORM_FIELDS.CAID]: string | number;
  [PROVIDER_DETAILS_FORM_FIELDS.BIN]: string | number;
  [PROVIDER_DETAILS_FORM_FIELDS.RISK_TIER]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_COUNT]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_VALUE]: number | string;
  [PROVIDER_DETAILS_FORM_FIELDS.NAME]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.EMAIL]: string;
  [PROVIDER_DETAILS_FORM_FIELDS.PHONE]: string;
}

export const providerDetailsFormInitialValues: IProviderDetailsForm = {
  [PROVIDER_DETAILS_FORM_FIELDS.PROVIDER_NAME]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.MCC]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_ID]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_MIT]: false,
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_CIT]: false,
  [PROVIDER_DETAILS_FORM_FIELDS.SANDBOX]: false,
  [PROVIDER_DETAILS_FORM_FIELDS.ETHOCA_PROVIDER]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.RDR_PROVIDER]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.CHARGEBACK_PROVIDER]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.FIXED_DESCRIPTOR_PREFIX]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.MC_DESCRIPTOR_PREFIX]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.PARTNER_ID]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.MERCHANT_NUMBER]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.SPONSOR_BANK]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_PLATFORM]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.CAID]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.BIN]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.RISK_TIER]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_COUNT]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_VALUE]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.NAME]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.EMAIL]: '',
  [PROVIDER_DETAILS_FORM_FIELDS.PHONE]: '',
};

export const getProviderDetailsValidationSchema = (t): Yup.SchemaOf<IProviderDetailsForm> => Yup.object<Shape<IProviderDetailsForm>>().shape({
  [PROVIDER_DETAILS_FORM_FIELDS.PROVIDER_NAME]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.MCC]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_ID]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_MIT]: Yup.boolean(),
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_CIT]: Yup.boolean(),
  [PROVIDER_DETAILS_FORM_FIELDS.SANDBOX]: Yup.boolean(),
  [PROVIDER_DETAILS_FORM_FIELDS.ETHOCA_PROVIDER]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.RDR_PROVIDER]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.CHARGEBACK_PROVIDER]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.FIXED_DESCRIPTOR_PREFIX]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.MC_DESCRIPTOR_PREFIX]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.PARTNER_ID]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.SPONSOR_BANK]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_PLATFORM]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.MERCHANT_NUMBER]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.CAID]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.BIN]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.RISK_TIER]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true)
    .typeError(''),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true)
    .typeError(''),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_COUNT]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_VALUE]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true)
    .typeError(''),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true)
    .typeError(''),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_COUNT]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_VALUE]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true)
    .typeError(''),
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true)
    .typeError(''),
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_COUNT]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_VALUE]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true),
  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE]: Yup.number()
    .nullable()
    .test('is-positive', 'Can`t be less than 0', value => value ? value > 0 : true),
  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_COUNT]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_VALUE]: Yup.number()
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.NAME]: Yup.string(),
  [PROVIDER_DETAILS_FORM_FIELDS.EMAIL]: Yup.string()
    .email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
    .nullable(),
  [PROVIDER_DETAILS_FORM_FIELDS.PHONE]: Yup.string()
    .nullable(),
});

export const convertToInitialProviderDetailsValues = (data: IFormattedProviderProps): IProviderDetailsForm => ({
  [PROVIDER_DETAILS_FORM_FIELDS.PROVIDER_NAME]: data?.[PROVIDER_DETAILS_FORM_FIELDS.PROVIDER_NAME] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.MCC]: data?.[PROVIDER_DETAILS_FORM_FIELDS.MCC] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_ID]: data?.[PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_ID] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_MIT]: data?.[PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_MIT] || false,
  [PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_CIT]: data?.[PROVIDER_DETAILS_FORM_FIELDS.SUPPORT_CIT] || false,
  [PROVIDER_DETAILS_FORM_FIELDS.SANDBOX]: data?.[PROVIDER_DETAILS_FORM_FIELDS.SANDBOX] || false,
  [PROVIDER_DETAILS_FORM_FIELDS.ETHOCA_PROVIDER]: data?.[PROVIDER_DETAILS_FORM_FIELDS.ETHOCA_PROVIDER] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.RDR_PROVIDER]: data?.[PROVIDER_DETAILS_FORM_FIELDS.RDR_PROVIDER] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.CHARGEBACK_PROVIDER]: data?.[PROVIDER_DETAILS_FORM_FIELDS.CHARGEBACK_PROVIDER] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.FIXED_DESCRIPTOR_PREFIX]: data?.[PROVIDER_DETAILS_FORM_FIELDS.FIXED_DESCRIPTOR_PREFIX] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.MC_DESCRIPTOR_PREFIX]: data?.[PROVIDER_DETAILS_FORM_FIELDS.MC_DESCRIPTOR_PREFIX] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX]: data?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.PARTNER_ID]: data?.[PROVIDER_DETAILS_FORM_FIELDS.PARTNER_ID] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.MERCHANT_NUMBER]: data?.[PROVIDER_DETAILS_FORM_FIELDS.MERCHANT_NUMBER] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.SPONSOR_BANK]: data?.[PROVIDER_DETAILS_FORM_FIELDS.SPONSOR_BANK] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_PLATFORM]: data?.[PROVIDER_DETAILS_FORM_FIELDS.PROCESSOR_PLATFORM] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.CAID]: data?.[PROVIDER_DETAILS_FORM_FIELDS.CAID] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.BIN]: data?.[PROVIDER_DETAILS_FORM_FIELDS.BIN] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.RISK_TIER]: data?.[PROVIDER_DETAILS_FORM_FIELDS.RISK_TIER] ? data?.[PROVIDER_DETAILS_FORM_FIELDS.RISK_TIER].toString() : '',

  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT]: data?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT],
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE]:
    data?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE] === null
      ? null
      : data?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE] / 100,

  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_COUNT]:
    data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_COUNT] >= 0
      ? data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_COUNT]
      : null,

  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_VALUE]:
    data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_VALUE] >= 0
      ? data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_VALUE] / 100
      : null,



  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT]: data?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE]:
    data?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE] === null || data?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE] === undefined
      ? null
      : data?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE] / 100,

  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_COUNT]:
    data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_COUNT] >= 0
    ? data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_COUNT]
    : null,

  [PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_VALUE]:
    data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_VALUE] >= 0
      ? data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_VALUE] / 100
      : null,



  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]: data?.[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT] || '',

  [PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE]:
    data?.[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE] === null
      ? null
      : data?.[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE] / 100,

  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_COUNT]:
    data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_COUNT] >= 0
      ? data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_COUNT]
      : null,

  [PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_VALUE]:
    data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_VALUE] >= 0
      ? data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_VALUE] / 100
      : null,

  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT]: data?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT] || '',

  [PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE] :
    data?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE] === null
      ? null
      : data?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE] / 100,

  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_COUNT]: data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_COUNT] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_VALUE]:
    data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_VALUE] > 0
      ? data?.cycleMetrics?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_VALUE] / 100
      : null,

  [PROVIDER_DETAILS_FORM_FIELDS.NAME]: data?.[PROVIDER_DETAILS_FORM_FIELDS.NAME] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.EMAIL]: data?.[PROVIDER_DETAILS_FORM_FIELDS.EMAIL] || '',
  [PROVIDER_DETAILS_FORM_FIELDS.PHONE]: data?.[PROVIDER_DETAILS_FORM_FIELDS.PHONE] || '',
});
